module.exports = __webpack_public_path__ + "a593ad963bebffbdf4616c8662ff5084.png";